import React, { Component } from "react"
import { FormControl, OverlayTrigger, Popover, Spinner, Tooltip } from "react-bootstrap"
import moment from "moment"
import TimelineTextEditor from "./TimelineTextEditor/TimelineTextEditor"
import dompurify from "dompurify"
import ReviewTimelineViewer from "./ReviewTimelineViewer/ReviewTimelineViewer"
import ReviewTimelineTypes from "../ReviewTypes/ReviewTimelineTypes"
import DocViewer from "../../../../HRUtilities/DocViewer/DocViewer"
import reggie from "../../../../../../utilities/Reggie"
import IconBuilder from "../../../../../../utilities/iconBuilder/IconBuilder"
import DocUploader from "../../../../HRUtilities/DocUploader/DocUploader"
import "./ReviewTimeline.css"
import DeleteReviewTimelineItem from "./DeleteReviewTimelineItem/DeleteReviewTimelineItem"
// import DeleteTimelineItem from "./ConfigureTimeline/DeleteTimelineItem/DeleteTimelineItem"

interface Props {
    manageParentState?: Function
    EmployeeReviewTimelineId: number
    timelineItems: Array<ReviewTimelineTypes>
    loadingTimeline: boolean
    timeFormat: string
    toggleLarge: Function
    isModal: boolean
    contextUserId: string | number
    refreshTimeline: Function
    updateTimeLineItems: Function
    readOnly: boolean
    defaultDocUploaderOpen?: boolean
}

type State = {
    input: string
    showActivity: boolean
    largeView: boolean
    uploadDocument: boolean
    viewDocument: boolean
    addEvent: boolean
    addForm: boolean
    EmployeeReviewTimelineTypeId: number
    ascending: boolean
    editIndex: string
    delete: boolean
    edit: boolean
    openItem: ReviewTimelineTypes | null
}

class ReviewTimeline extends Component<Props, State> {

    longDateFormat = "lll"
    copy: Array<ReviewTimelineTypes> = []
    storageLocation = process.env.REACT_APP_REVIEWS_STORAGE_LOCATION || ""
    containerName = process.env.REACT_APP_REVIEWS_CONTAINER_NAME || ""
    fileStoreLocationId = process.env.REACT_APP_REVIEWS_IMAGE_FILE_STORE_LOCATION_ID || ""

    state = {
        input: "",
        showActivity: true,
        largeView: true,
        uploadDocument: false,
        viewDocument: true,
        addEvent: false,
        addForm: false,
        EmployeeReviewTimelineTypeId: -1,
        ascending: true,
        editIndex: "-1",
        delete: false,
        edit: false,
        openItem: null
    }

    componentDidMount(): void {
        if (this.props.defaultDocUploaderOpen) {
            this.manageState([{ key: "uploadDocument", value: true }])
        }
    }

    handleChange = (event: { target: { value: string } }) => {
        this.setState({ input: event.target.value })
    }

    filter = (input: string, timelineItems: Array<ReviewTimelineTypes>) => {
        let temp = []
        for (let i = 0; i < timelineItems.length; i++) {
            let str = Object.values(timelineItems[i]).join().toLowerCase()
            if (str.includes(input.toLowerCase())) {
                temp.push(timelineItems[i])
            }
        }
        return temp
    }

    clearInput = () => {
        this.setState({ input: "" })
    }

    manageState = (items: Array<{ key: string, value?: any }>) => {
        let temp: any = this.state
        for (let i = 0; i < items.length; i++) {
            if (items[i].value) {
                temp[items[i].key] = items[i].value
            } else {
                if (!temp[items[i].key]) {
                    temp[items[i].key] = true
                } else {
                    temp[items[i].key] = false
                }
            }
        }
        this.setState(temp)
    }

    sortTimelineItems = (items: Array<any>) => {
        // if (this.state.ascending) {
        //     return items.sort((a: any, b: any) => (a.EmployeeReviewTimelineTypeId < b.EmployeeReviewTimelineTypeId) ? 1 : -1)
        // } else if (!this.state.ascending) {
        //     return items.sort((a: any, b: any) => (a.EmployeeReviewTimelineTypeId > b.EmployeeReviewTimelineTypeId) ? 1 : -1)
        // }
        return items
    }

    toggleOpenTimelineItem = (timelineItem: ReviewTimelineTypes | null) => {
        if (this.state.openItem) {
            this.setState({ openItem: null })
        } else {
            this.setState({ openItem: timelineItem })
        }
    }

    getFileTitle = (title: string | null) => {
        if (title) {
            let arr = title.split("_")
            return arr.slice(1, -1).join("_")
        }
        return "NA"
    }

    render() {

        let timelineItems: Array<ReviewTimelineTypes> = this.sortTimelineItems(this.props.timelineItems)
        const openItem = this.state.openItem
        const temp = JSON.parse(JSON.stringify(this.props.timelineItems))
        const readOnly = this.props.readOnly
        const date = new Date();
        const offset = -date.getTimezoneOffset();

        for (let i = 0; i < timelineItems.length; i++) {
            timelineItems[i].EmployeeReviewTimelineTypeDesc = reggie.joinString(timelineItems[i].EmployeeReviewTimelineTypeDesc.toLowerCase())
            if (timelineItems[i].EmployeeReviewTimelineTypeId === 1) {
                //@ts-ignore
                timelineItems[i].extension = reggie.getFileExtensionFromString(timelineItems[i].FileName)
            }
        }

        if (this.state.input !== "") {
            timelineItems = this.filter(this.state.input, temp)
        }

        const TimelineToolTip = (text: string) => (
            <Tooltip id="timeline-tool-tip" >
                {text}
            </Tooltip>
        )

        const TimelinePopover = (text: string) => (
            <Popover id="timeline-popover">
                <Popover.Content>
                    <span dangerouslySetInnerHTML={{ __html: dompurify.sanitize(text) }} />
                </Popover.Content>
            </Popover>
        )

        // //console.log("Review Timeline Props: ", this.props)

        return (
            <div className="ReviewTimeline" id={`review-review-timeline-large-view-${this.state.largeView}`}>
                {timelineItems.length > 0 && <div className="ReviewTimelineControls" id={`review-timeline-controls-modal-${this.props.isModal}`}>
                    <div className="WorkersCompViewTypeToggle">
                        <div id={`review-timeline-show-activity-wrapper-modal-${this.props.isModal}`} onClick={() => this.manageState([{ key: "showActivity" }])}>
                            <p>Show Activity</p>
                            {this.state.showActivity && <div className="WorkersCompViewTypeToggleChecked"></div>}
                            {!this.state.showActivity && <div className="WorkersCompViewTypeToggleUnchecked"></div>}
                        </div>
                    </div>
                    <div className="ReviewTimelineFilter">
                        <div className="ReviewTimelineFilterIcons" id={`review-timeline-filter-icons-modal-${this.props.isModal}`}>
                            {this.state.input === "" && <span className="material-icons">filter_alt</span>}
                            {this.state.input !== "" && <span className="material-icons" onClick={() => this.clearInput()}>close</span>}
                        </div>
                        <FormControl
                            placeholder={"Search Timeline"}
                            aria-describedby="basic-addon1"
                            onChange={this.handleChange}
                            value={this.state.input}
                        />
                    </div>
                </div>}
                {!this.props.loadingTimeline && !readOnly && <div className="ReviewTimelineAddButtonsWrapper" id={`review-timeline-add-btns-wrapper-modal-${this.props.isModal}`}>
                    <div className="ReviewTimelineAddButtons">
                        <div className="ReviewTimelineAddBtn" onClick={() => this.manageState([{ key: "uploadDocument" }])}>
                            <span className="material-icons">description</span>
                            <p>Upload Files</p>
                        </div>
                        {/* <div className="ReviewTimelineAddBtn" onClick={() => this.manageState([{ key: "EmployeeReviewTimelineTypeId", value: 2 }, { key: "addEvent" }])}>
                            <span className="material-icons">email</span>
                            <p>Add Correspondence</p>
                        </div> */}
                        <div className="ReviewTimelineAddBtn" onClick={() => this.manageState([{ key: "EmployeeReviewTimelineTypeId", value: 3 }, { key: "addEvent" }])}>
                            <span className="material-icons">chat</span>
                            <p>Add Note</p>
                        </div>
                        {/* <div className="ReviewTimelineAddBtn" onClick={() => this.manageState([{ key: "EmployeeReviewTimelineTypeId", value: 4 }, { key: "addEvent" }])}>
                            <span className="material-icons">event</span>
                            <p>Add Event</p>
                        </div>
                        <div className="ReviewTimelineAddBtn" onClick={() => this.manageState([{ key: "EmployeeReviewTimelineTypeId", value: 5 }, { key: "addForm" }])}>
                            <span className="material-icons">dynamic_feed</span>
                            <p>Add Form</p>
                        </div> */}
                    </div>
                </div>}
                <div className="ReviewTimelineContent" id={`review-timeline-content-modal-${this.props.isModal}`}>
                    {this.props.loadingTimeline && <Spinner id="review-timeline-load-spinner" animation="border" />}
                    {timelineItems.length > 0 && timelineItems.map((item: ReviewTimelineTypes, index: number) =>
                        <div className="ReviewTimelineItemWrapper" key={item.EmployeeReviewTimelineId}>
                            {item && item.EmployeeReviewTimelineTypeId !== 6 && <div className="ReviewTimelineItem">
                                <div className="ReviewTimelineItemBodyLeft">
                                    <div className="ReviewTimelineItemTypeMarker">
                                        {item.extension && <IconBuilder extension={item.extension} size={48} />}
                                        {item.EmployeeReviewTimelineTypeDesc.toLowerCase() === "correspondence" && <span className="material-icons">email</span>}
                                        {item.EmployeeReviewTimelineTypeDesc.toLowerCase() === "note" && <span className="material-icons">chat</span>}
                                        {item.EmployeeReviewTimelineTypeDesc.toLowerCase() === "event" && <span className="material-icons">event</span>}
                                    </div>
                                    <div className="ReviewTimelineItemDescription">
                                        <div className="ReviewTimelineItemDescriptionUpper" onClick={() => this.toggleOpenTimelineItem(item)}>
                                            <p className="ReviewTimelineItemDescriptionUpperDate">{moment.utc(item.CreatedDateUTC).utcOffset(offset).format(this.props.timeFormat) || "*NA*"}</p>
                                            <p className="ReviewTimelineItemDescriptionUpperTitle">{item.TimelineTitle}</p>
                                        </div>
                                        <div className="ReviewTimelineItemLower">
                                            <p>{moment.utc(item.TimelineDateUtc).utcOffset(offset).format(this.props.timeFormat) || "*NA*"} by {item.CreatedByName}</p>
                                            {item.NoteText && <OverlayTrigger delay={{ show: 0, hide: 0 }} placement="top" overlay={TimelinePopover(item.NoteText)}>
                                                <span id="review-timelineitem-preview-marker" className="material-icons">chat</span>
                                            </OverlayTrigger>}
                                            {/* {item.EmployeeReviewTimelineTypeDesc === "document" && <OverlayTrigger delay={{ show: 0, hide: 0 }} placement="top" overlay={TimelinePopover(item.NoteText)}>
                                                <span id="review-timelineitem-document-comments-marker" className="material-icons">chat</span>
                                            </OverlayTrigger>} */}
                                        </div>
                                    </div>
                                </div>
                                {!readOnly && <div className="ReviewTimelineItemBodyRight">
                                    {/* {item.EmployeeReviewTimelineTypeDesc === "document" && <div className="ReviewTimelineItemDocumentTitle">
                                        <p>{item.TimelineTitle}</p>
                                    </div>} */}
                                    <div className="ReviewTimelineItemRightControls">
                                        {/*Need API support*/}
                                        {<OverlayTrigger delay={{ show: 0, hide: 0 }} placement="left" overlay={TimelineToolTip("Delete Timeline item")}>
                                            <span id="delete-review-timeline-item-btn" className="material-icons" onClick={() => this.manageState([{ key: "editIndex", value: index + "" }, { key: "delete" }])}>delete</span>
                                        </OverlayTrigger>}
                                        {!item.extension && <OverlayTrigger delay={{ show: 0, hide: 0 }} placement="left" overlay={TimelineToolTip("Edit Note")}>
                                            <span id="edit-review-timeline-item-btn" className="material-icons" onClick={() => this.manageState([{ key: "editIndex", value: index + "" }, { key: "edit" }])}>edit</span>
                                        </OverlayTrigger>}
                                        {/* {item.extension && <OverlayTrigger delay={{ show: 0, hide: 0 }} placement="left" overlay={TimelineToolTip("")}>
                                            <span id="edit-review-timeline-item-btn" className="material-icons" onClick={() => this.manageState([{ key: "editIndex", value: index + "" }, { key: "edit" }])}>edit</span>
                                        </OverlayTrigger>} */}
                                        {<OverlayTrigger delay={{ show: 0, hide: 0 }} placement="left" overlay={TimelineToolTip("Expand Timeline item")}>
                                            <span id="expand-review-timeline-item-btn" className="material-icons" onClick={() => this.toggleOpenTimelineItem(item)}>open_in_full</span>
                                        </OverlayTrigger>}
                                        {/* {item.IsLocked && <OverlayTrigger delay={{ show: 0, hide: 0 }} placement="left" overlay={TimelineToolTip("Timeline item locked")}>
                                            <span id="review-timeline-item-locked-marker" className="material-icons">lock</span>
                                        </OverlayTrigger>} */}
                                    </div>
                                </div>}
                            </div>}
                            {this.state.showActivity && item.EmployeeReviewTimelineTypeDesc === "activity" && <div className="ReviewTimelineItemActivity" key={item.EmployeeReviewTimelineTypeId}>
                                <div className="ReviewTimelineActivityBodyLeft">
                                    <span className="material-icons">timeline</span>
                                </div>
                                <div className="ReviewTimelineActivityBodyRight">
                                    <div className="ReviewTimelineActivityBodyRightUpper">
                                        <p className="ReviewTimelineActivityBodyRightUpperDate">{moment.utc(item.TimelineDateUtc).format(this.props.timeFormat) || "*NA*"}</p>
                                        <p className="ReviewTimelineActivityBodyRightUpperType">{item.EmployeeReviewTimelineTypeDesc}</p>
                                    </div>
                                    {item.NoteText}
                                </div>
                            </div>}
                        </div>)}
                    {timelineItems.length === 0 && <div className="ReviewTimelineFooter">
                        <div className="ReviewTimelineFooterTextWrapper">
                            <p>No timeline items yet.</p>
                            <p>Use the buttons above to add to the reviews timeline.</p>
                        </div>
                    </div>}
                </div>
                {this.state.uploadDocument &&
                    <DocUploader
                        manageParentState={this.manageState}
                        manageGrandparentState={this.props.manageParentState}
                        timelineId={this.props.EmployeeReviewTimelineId}
                        contextUserId={this.props.contextUserId}
                        refreshTimeline={this.props.refreshTimeline}
                        timelineEndpoint={"/api/employeeReview/addOrUpdateReviewTimeline"}
                        timelineType="review"
                        storageLocation={this.storageLocation}
                        containerName={this.containerName}
                        fileStoreLocationId={this.fileStoreLocationId}
                        uploadOnDrop={true}
                    />}
                {this.state.addEvent && <TimelineTextEditor
                    EmployeeReviewTimelineTypeId={this.state.EmployeeReviewTimelineTypeId}
                    EmployeeReviewId={this.props.EmployeeReviewTimelineId}
                    contextUserId={this.props.contextUserId}
                    toggleTextEditor={this.manageState}
                    refreshTimeline={this.props.refreshTimeline}
                />}
                {/* {this.state.addForm && <AddTimelineForm
                    userId={this.props.userId}
                    toggleAddForm={this.manageState}
                />} */}
                {this.state.edit && <TimelineTextEditor
                    EmployeeReviewTimelineTypeId={timelineItems[parseInt(this.state.editIndex)].EmployeeReviewTimelineTypeId}
                    EmployeeReviewId={this.props.EmployeeReviewTimelineId}
                    contextUserId={this.props.contextUserId}
                    toggleTextEditor={this.manageState}
                    refreshTimeline={this.props.refreshTimeline}
                    item={timelineItems[parseInt(this.state.editIndex)]}
                />}
                {/*@ts-ignore*/}
                {openItem && openItem.extension && <DocViewer
                    //@ts-ignore
                    extension={openItem.extension}
                    //@ts-ignore
                    fileName={openItem.FileName}
                    toggleDocViewer={this.toggleOpenTimelineItem}
                    getFileTitle={this.getFileTitle}
                    //@ts-ignore
                    displayName={openItem.TimelineTitle}
                    containerName={this.containerName}
                    storageLocation={this.storageLocation}
                />}
                {this.state.delete && <DeleteReviewTimelineItem
                    timeLineItem={timelineItems[parseInt(this.state.editIndex)]}
                    toggleDelete={() => this.manageState([{ key: "delete" }, { key: "editIndex", value: -1 }])}
                    deleteReviewTimelineItem={this.props.updateTimeLineItems}
                    contextUserId={this.props.contextUserId}
                />}
                {/*@ts-ignore*/}
                {openItem && !openItem.extension &&
                    <ReviewTimelineViewer
                        openItem={openItem}
                        toggleReviewTimelineViewer={this.toggleOpenTimelineItem}
                    />}
            </div>
        )
    }
}

export default ReviewTimeline